// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","imageContainer":"Card_imageContainer__Iv5oU","caption":"Card_caption__MnUaD"};